// Generator function to create random mock data for the encounters table
import { Encounter } from 'types/encounter';

export default function makeData(): Encounter[] {
  return generateRandomEncounters(100);
}

// Helper functions to generate random data
const getRandomInt = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const getRandomDate = (
  start: Date = new Date(2019, 0, 1),
  end: Date = new Date()
): Date => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

const formatDate = (date: Date): string => {
  return date.toISOString();
};

// Generate a random string of specified length
const getRandomString = (length = 10): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  return Array.from(
    { length },
    () => chars[Math.floor(Math.random() * chars.length)]
  ).join('');
};

// Generate a random status
const getRandomStatus = (): string => {
  const statuses = ['OnHold', 'Void', 'Pending', 'Complete', 'Rejected'];
  return statuses[getRandomInt(0, statuses.length - 1)];
};

// Generate a random gender value
const getRandomGender = (): string => {
  const genders = ['M', 'F', 'O', 'U'];
  return genders[getRandomInt(0, genders.length - 1)];
};

// Main generator function
function generateRandomEncounters(count: number): Encounter[] {
  const encounters: Encounter[] = [];

  for (let i = 0; i < count; i++) {
    const facilityID = getRandomInt(20, 30);
    const status = getRandomStatus();
    const dateOfService = getRandomDate(
      new Date(2020, 0, 1),
      new Date(2023, 11, 31)
    );
    const patientDOB = getRandomDate(
      new Date(1930, 0, 1),
      new Date(2000, 11, 31)
    );
    const dateHeld = getRandomDate(
      new Date(2007, 0, 1),
      new Date(2015, 11, 31)
    );
    const encounterHeaderID = getRandomInt(100000000, 9999999999);

    const encounter: Encounter = {
      environment: getRandomString(3),
      encounterHeaderID: encounterHeaderID,
      encounterHeaderIdentifier: encounterHeaderID, // For compatibility
      facilityAccountNumber: getRandomInt(100, 999).toString(),
      patientName: getRandomString(8),
      dateOfService: formatDate(dateOfService),
      providerName: getRandomString(12),
      providerMidLevelName: getRandomString(10),
      providerResidentName: getRandomString(10),
      lastComment: getRandomString(20),
      voidDate:
        status === 'Void'
          ? formatDate(getRandomDate(dateOfService, new Date()))
          : '',
      status: status,
      facilityID: facilityID,
      facilityName: `Facility-${getRandomString(5)}`,
      mrn: getRandomInt(100000, 999999).toString(),
      patientDOB: formatDate(patientDOB),
      dateHeld: formatDate(dateHeld),
      insurance: getRandomString(15),
      scribe: getRandomString(8),
      incompleteReason: getRandomString(12),
      responsibleProvider: getRandomString(12),
      attendingProvider: getRandomString(12),
      partnerPortalAllowExceptionManagement: Math.random() > 0.5,
      actionOwner: getRandomString(6),
      nextCheckDate: '0001-01-01T00:00:00',
      applicationID: 1,
      patientGender: getRandomGender()
    };

    encounters.push(encounter);
  }

  return encounters;
}
